/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Unit_Suffix_M2_DayInputs */

const cs_price_unit_suffix_m2_day = /** @type {(inputs: Price_Unit_Suffix_M2_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/m²/den`)
};

const en_price_unit_suffix_m2_day = /** @type {(inputs: Price_Unit_Suffix_M2_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/m²/day`)
};

/**
* | output |
* | --- |
* | "/m²/day" |
*
* @param {Price_Unit_Suffix_M2_DayInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const price_unit_suffix_m2_day = /** @type {((inputs?: Price_Unit_Suffix_M2_DayInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Unit_Suffix_M2_DayInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_price_unit_suffix_m2_day(inputs)
	return cs_price_unit_suffix_m2_day(inputs)
});